function generateMedicalSummary(data) {
  let summary = [];

  // Helper function to check if an object is empty
  const isEmpty = (obj) => {
    return Object.keys(obj).length === 0;
  };

  // Helper function to format data point
  const formatDataPoint = (label, value) => {
    if (!value) return null;
    return `${label}: ${value}`;
  };

  // Process each data type
  for (const [key, value] of Object.entries(data)) {
    // Skip tabTitleList and totalDataNum
    if (key === 'tabTitleList' || key === 'totalDataNum') continue;

    // Check if this data type has any content
    if (!isEmpty(value.descriptionData) || value.tableData.length > 0) {
      let sectionSummary = [];

      // Process description data
      if (!isEmpty(value.descriptionData)) {
        sectionSummary.push(`${key} Information:`);
        for (const [dataKey, dataValue] of Object.entries(
          value.descriptionData,
        )) {
          const formattedPoint = formatDataPoint(
            dataKey.charAt(0).toUpperCase() +
              dataKey.slice(1).replace(/([A-Z])/g, ' $1'),
            dataValue,
          );
          if (formattedPoint) sectionSummary.push(`- ${formattedPoint}`);
        }
      }

      // Process table data
      if (value.tableData.length > 0) {
        if (sectionSummary.length === 0) {
          sectionSummary.push(`${key} Records:`);
        }
        value.tableData.forEach((record, index) => {
          if (!isEmpty(record)) {
            if (value.tableData.length > 1) {
              sectionSummary.push(`\nRecord ${index + 1}:`);
            }
            for (const [recordKey, recordValue] of Object.entries(record)) {
              const formattedPoint = formatDataPoint(
                recordKey.charAt(0).toUpperCase() +
                  recordKey.slice(1).replace(/([A-Z])/g, ' $1'),
                recordValue,
              );
              if (formattedPoint) sectionSummary.push(`- ${formattedPoint}`);
            }
          }
        });
      }

      if (sectionSummary.length > 0) {
        summary.push(sectionSummary.join('\n'));
      }
    }
  }

  return summary.join('\n\n');
}
export default generateMedicalSummary;
